
import {postKyc} from '../api/postKyc';
import {setGetKyc} from './setGetKyc';

const setPostKyc = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postKyc(params);

            if (data.status === 'success') {
                dispatch(setGetKyc({
                    page: 1,
                    rowsPerPage: 10,
                    search: ''
                }));
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostKyc
}